// import React, { Component } from "react";
// import axios from "axios";

// class DisplayQuestion extends Component {
//   state = {
//     loading: false,
//     questions: [],
//     currentIndex: 0,
//     answers: {
//       exam_id: this.props.exam_id,
//       answers: [],
//     },
//   };

//   componentDidMount() {
//     this.fetchQuestion();
//   }

//   fetchQuestion = async () => {
//     const accessToken = localStorage.getItem("accessToken");
//     const exam_id = this.props.exam_id;

//     try {
//       const response = await axios.get(
//         `https://api.geoinfoacademy.com/api/student/questions/by-exam/${exam_id}/`,
//         {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//           },
//         }
//       );

//       const res =
//         !response.data || Object.keys(response.data).length < 1
//           ? [
//             {
//               id: 1,
//               text: "",
//               selector: "single",
//               drop_down_open: false,
//               option_no: 2,
//               options: [
//                 { id: 1, text: "", is_correct: false },
//                 { id: 2, text: "", is_correct: false },
//               ],
//               instruction: "",
//               points: "",
//             },
//           ]
//           : response.data;

//       // Initialize answers state for each question
//       const answers = res.map((q) => ({
//         question_id: q.id,
//         selected_option_ids: [],
//       }));

//       this.setState({
//         questions: res,
//         answers: {
//           exam_id: exam_id,
//           answers,
//         },
//       });

//       console.log("API Response Questions:", response.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };




//   handleSubmit = async () => {
//     const { answers } = this.state;
//     const accessToken = localStorage.getItem("accessToken");

//     try {
//       const response = await axios.post(
//         "https://api.geoinfoacademy.com/api/student/submissions/submit/",
//         answers,
//         {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       console.log("Submission successful:", response.data);
//       alert("Your answers have been submitted successfully!");
//       // You can redirect the user or reset the form here if needed.
//     } catch (error) {
//       console.error("Submission error:", error);
//       alert("There was an error submitting your answers. Please try again.");
//     }
//   };








//   handleNext = () => {
//     this.setState((prev) => ({
//       currentIndex:
//         prev.currentIndex < prev.questions.length - 1
//           ? prev.currentIndex + 1
//           : prev.currentIndex,
//     }));
//   };

//   handlePrevious = () => {
//     this.setState((prev) => ({
//       currentIndex: prev.currentIndex > 0 ? prev.currentIndex - 1 : 0,
//     }));
//   };

//   // 👉 Handle option select
//   handleOptionSelect = (questionId, optionId, type) => {
//     this.setState((prev) => {
//       const newAnswers = prev.answers.answers.map((ans) => {
//         if (ans.question_id === questionId) {
//           if (type === "single") {
//             // radio → replace with single selected option
//             return { ...ans, selected_option_ids: [optionId] };
//           } else {
//             // checkbox → toggle add/remove
//             const alreadySelected = ans.selected_option_ids.includes(optionId);
//             const updatedOptions = alreadySelected
//               ? ans.selected_option_ids.filter((id) => id !== optionId)
//               : [...ans.selected_option_ids, optionId];
//             return { ...ans, selected_option_ids: updatedOptions };
//           }
//         }
//         return ans;
//       });

//       return {
//         ...prev,
//         answers: { ...prev.answers, answers: newAnswers },
//       };
//     });
//   };

//   render() {
//     const { questions, currentIndex, answers } = this.state;
//     const currentQuestion = questions[currentIndex];

//     if (questions.length === 0) {
//       return <p>Loading questions...</p>;
//     }

//     // Find current question's saved answer
//     const currentAnswer = answers.answers.find(
//       (a) => a.question_id === currentQuestion.id
//     ) || { selected_option_ids: [] };

//     return (
//       <div className="dash_exam_container">
//         <div className="dash_content">
//           <nav className="navigate">
//             <span>
//               Question {currentIndex + 1} of {questions.length}
//             </span>
//             <span>20:00</span>
//           </nav>

//           <div className="question_container" key={currentQuestion.id}>
//             <div className="container">
//               <section className="exam_preview">
//                 {currentQuestion.instruction && (
//                   <h5>{currentQuestion.instruction}</h5>
//                 )}
//                 <div className="head">
//                   <div className="number">
//                     <span>{currentIndex + 1}</span>
//                   </div>
//                   <div className="writeup">
//                     <h4>
//                       {currentQuestion.text.trim()
//                         ? currentQuestion.text
//                         : "What is GIS ?"}
//                     </h4>
//                   </div>
//                 </div>

//                 {currentQuestion.options.map((opt) => (
//                   <div className="option" key={opt.id}>
//                     <input
//                       type={
//                         currentQuestion.selector === "single"
//                           ? "radio"
//                           : "checkbox"
//                       }
//                       name={`preview-${currentQuestion.id}`}
//                       checked={currentAnswer.selected_option_ids.includes(
//                         opt.id
//                       )}
//                       onChange={() =>
//                         this.handleOptionSelect(
//                           currentQuestion.id,
//                           opt.id,
//                           currentQuestion.selector
//                         )
//                       }
//                     />
//                     <p>{opt.text.trim() || "Question Option"}</p>
//                   </div>
//                 ))}
//               </section>
//             </div>
//           </div>

//           <nav className="navigate">
//             <button onClick={this.handlePrevious} disabled={currentIndex === 0}>
//               Previous
//             </button>
//             <button
//               className="blue"
//               onClick={
//                 currentIndex === questions.length - 1
//                   ? this.handleSubmit
//                   : this.handleNext
//               }
//               disabled={questions.length === 0}
//             >
//               {currentIndex === questions.length - 1 ? "Finish" : "Next"}
//             </button>
//           </nav>
//         </div>

//         {/* Debug answers (remove in prod) */}
//         {/* <pre>{JSON.stringify(this.state.answers, null, 2)}</pre> */}
//       </div>
//     );
//   }
// }

// export default DisplayQuestion;




















import React, { Component } from "react";
import axios from "axios";
import DisplayExamScore from "./display_exam_score";

class DisplayQuestion extends Component {
  state = {
    loading: false,
    questions: [],
    currentIndex: 0,
    answers: {
      exam_id: this.props.exam_id,
      answers: [],
    },
    countdownDisplay: "00:00", // for showing countdown
    toggle: false,
    response: [],

  };

  countdown = null; // setInterval ID
  countdownEndTime = null; // target time to stop countdown
  examSubmitted = false; // flag to track if submitted

  componentDidMount() {
    this.fetchQuestion();
    this.initCountdown();
  }

  componentWillUnmount() {
    if (this.countdown) {
      clearInterval(this.countdown);
    }
  }

  // 🕒 Initialize Countdown
  initCountdown = () => {
    const minutes = parseInt(localStorage.getItem("examCountDown"), 10);
    // localStorage.removeItem("examCountDown"); // clear it after reading

    if (!isNaN(minutes)) {
      const now = Date.now();
      this.countdownEndTime = now + minutes * 60 * 1000;

      this.updateCountdown(); // call once immediately
      this.countdown = setInterval(this.updateCountdown, 1000); // update every second
    }
  };

  updateCountdown = () => {
    console.log("Updating countdown..."); // add this
    const now = Date.now();
    const remaining = this.countdownEndTime - now;

    if (remaining <= 0) {
      this.setState({ countdownDisplay: "00:00" });
      clearInterval(this.countdown);
      if (!this.examSubmitted) {
        this.handleSubmit();
      }
      return;
    }

    const minutes = Math.floor(remaining / 1000 / 60);
    const seconds = Math.floor((remaining / 1000) % 60);
    const padded = (n) => (n < 10 ? "0" + n : n);
    const formatted = `${padded(minutes)}:${padded(seconds)}`;

    this.setState({ countdownDisplay: formatted });
  };


  fetchQuestion = async () => {
    const accessToken = localStorage.getItem("accessToken");
    const exam_id = this.props.exam_id;

    try {
      const response = await axios.get(
        `https://api.geoinfoacademy.com/api/student/questions/by-exam/${exam_id}/`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const res =
        !response.data || Object.keys(response.data).length < 1
          ? [
            {
              id: 1,
              text: "",
              selector: "single",
              drop_down_open: false,
              option_no: 2,
              options: [
                { id: 1, text: "", is_correct: false },
                { id: 2, text: "", is_correct: false },
              ],
              instruction: "",
              points: "",
            },
          ]
          : response.data;

      const answers = res.map((q) => ({
        question_id: q.id,
        selected_option_ids: [],
      }));

      this.setState({
        questions: res,
        answers: {
          exam_id: exam_id,
          answers,
        },
      });

      console.log("API Response Questions:", response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleSubmit = async () => {
    const { answers } = this.state;
    const accessToken = localStorage.getItem("accessToken");

    if (this.examSubmitted) return; // prevent multiple submits

    this.examSubmitted = true;
    if (this.countdown) clearInterval(this.countdown); // stop timer

    try {
      const response = await axios.post(
        "https://api.geoinfoacademy.com/api/student/submissions/submit/",
        answers,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Submission successful:", response.data);
      localStorage.removeItem("examCountDown");
      this.setState({
        response : response.data
      })
      // window.location.replace(`/exam-score/${this.props.exam_id}`)
      // Optional: Redirect or disable further actions
      this.handleToggle()
    } catch (error) {
      console.error("Submission error:", error);
      alert("There was an error submitting your answers. Please try again.");
    }
  };

  handleNext = () => {
    this.setState((prev) => ({
      currentIndex:
        prev.currentIndex < prev.questions.length - 1
          ? prev.currentIndex + 1
          : prev.currentIndex,
    }));
  };

  handlePrevious = () => {
    this.setState((prev) => ({
      currentIndex: prev.currentIndex > 0 ? prev.currentIndex - 1 : 0,
    }));
  };

  handleOptionSelect = (questionId, optionId, type) => {
    this.setState((prev) => {
      const newAnswers = prev.answers.answers.map((ans) => {
        if (ans.question_id === questionId) {
          if (type === "single") {
            return { ...ans, selected_option_ids: [optionId] };
          } else {
            const alreadySelected = ans.selected_option_ids.includes(optionId);
            const updatedOptions = alreadySelected
              ? ans.selected_option_ids.filter((id) => id !== optionId)
              : [...ans.selected_option_ids, optionId];
            return { ...ans, selected_option_ids: updatedOptions };
          }
        }
        return ans;
      });

      return {
        ...prev,
        answers: { ...prev.answers, answers: newAnswers },
      };
    });
  };






  handleToggle = () => {
    this.setState({ toggle: !this.state.toggle });
  };






  render() {
    const { questions, currentIndex, answers, countdownDisplay, toggle } = this.state;
    const currentQuestion = questions[currentIndex];

    if (questions.length === 0) {
      return <p>Loading questions...</p>;
    }

    const currentAnswer =
      answers.answers.find((a) => a.question_id === currentQuestion.id) || {
        selected_option_ids: [],
      };

    return (
      <>
        <div className="dash_exam_container">
          <div className="dash_content">
            <nav className="navigate">
              <span>
                Question {currentIndex + 1} of {questions.length}
              </span>
              <span>{countdownDisplay}</span>
            </nav>

            <div className="question_container" key={currentQuestion.id}>
              <div className="container">
                <section className="exam_preview">
                  {currentQuestion.instruction && (
                    <h5>{currentQuestion.instruction}</h5>
                  )}
                  <div className="head">
                    <div className="number">
                      <span>{currentIndex + 1}</span>
                    </div>
                    <div className="writeup">
                      <h4>
                        {currentQuestion.text.trim()
                          ? currentQuestion.text
                          : "What is GIS ?"}
                      </h4>
                    </div>
                  </div>

                  {currentQuestion.options.map((opt) => (
                    <div className="option" key={opt.id}>
                      <input
                        type={
                          currentQuestion.selector === "single"
                            ? "radio"
                            : "checkbox"
                        }
                        name={`preview-${currentQuestion.id}`}
                        checked={currentAnswer.selected_option_ids.includes(
                          opt.id
                        )}
                        onChange={() =>
                          this.handleOptionSelect(
                            currentQuestion.id,
                            opt.id,
                            currentQuestion.selector
                          )
                        }
                      />
                      <p>{opt.text.trim() || "Question Option"}</p>
                    </div>
                  ))}
                </section>
              </div>
            </div>

            <nav className="navigate">
              <button onClick={this.handlePrevious} disabled={currentIndex === 0}>
                Previous
              </button>
              <button
                className="blue"
                onClick={
                  currentIndex === questions.length - 1
                    ? this.handleSubmit
                    : this.handleNext
                }
                disabled={questions.length === 0}
              >
                {currentIndex === questions.length - 1 ? "Finish" : "Next"}
              </button>
            </nav>
          </div>

          {/* Debug answers (remove in production) */}
          {/* <pre>{JSON.stringify(this.state.answers, null, 2)}</pre> */}
        </div>
        {toggle ? <DisplayExamScore handleToggle={this.handleToggle} response={this.state.response} /> : null}
      </>
    );
  }
}

export default DisplayQuestion;
